import { useLocation } from 'react-router-dom';

// The one place the feedback screen's route is written down.
//
// Three callers have to agree on it: the route table, the invitation banner (#212) and the
// standing link (#234). The two offers also share a rule -- neither says anything while the user
// is already on the screen it offers -- so the rule lives here beside the path rather than being
// restated wherever an offer is made.
export const FEEDBACK_PATH = '/feedback';

// The screens that already make the offer: the form the offers point at, and the record that
// invites a first submission or links to the form (#233). Standing on either, an offer is a
// second copy of a call to action the user is looking at.
const FEEDBACK_PATHS = [FEEDBACK_PATH, '/feedbacks'];

export function useOnFeedbackScreen() {
  return FEEDBACK_PATHS.includes(useLocation().pathname);
}
